/**
 * The application's URLs, named once.
 *
 * Router definitions and every navigate()/link in the app read from here, so a
 * path is never spelled out twice — the usual way a redirect ends up pointing
 * at a route that was renamed months ago.
 */
export const routes = {
  root: '/',
  login: '/login',
  dashboard: '/dashboard',
  notFound: '*'
};
